import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_OVERVIEW_ITINERARY_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/75555523444/trip-overview.pdf
 * https://lobot.prod.expedia.com/highlander/endpoints/20046
 */
export class TripOverviewItineraryController implements Controller {
  public readonly bundles = [];
  public readonly pageId = 'page.Trip.OverviewItinerary,U,80';
  public readonly routeName = 'trip-overview-itinerary';
  public readonly exact = true;
  public readonly path = `${BASEPATH}/trips/:tripViewId([a-z0-z-]+)/trip-overview.pdf`;
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-overview-itinerary" */ 'views/trip-overview-itinerary-view')
  );
  public readonly pageName = 'page.Trip.OverviewItinerary';
  public readonly clickstreamPageName = 'Trip Overview Itinerary';

  public shouldStreamResponse(): boolean {
    return false;
  }

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_OVERVIEW_ITINERARY_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trip-overview-itinerary-controller'
    });

    return Promise.resolve();
  }
}
